module.exports = __webpack_public_path__ + "static/img-menu-ef8363e3abeb94ae762136b1b8dc53de.jpg";